import React from 'react';

const SearchMenu = () => {
    return (
<>
<div class="search-popup">
	<button class="close-search style-two"><span class="flaticon-multiply"></span></button>
	<button class="close-search"><span class="flaticon-up-arrow-1"></span></button>
	<form method="post" action="blog.html">
		<div class="form-group">
			<input type="search" name="search-field" value="" placeholder="Search Here" required=""/>
			<button type="submit"><i class="fa fa-search"></i></button>
		</div>
	</form>
</div>
</>

);
};

export default SearchMenu;